import React from 'react';

import { makeStyles, LinearProgress, LinearProgressProps } from "@material-ui/core";

type TableLinearLoadingProps = LinearProgressProps & {
    isLoading?: boolean
};

export function TableLinearLoading ({ isLoading, ...props }: TableLinearLoadingProps) {
    const cls = useStyles();

    return isLoading ? <LinearProgress {...props} className={cls.root} /> : null
}

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%'
    }
}));